import { io } from 'socket.io-client';
import ClientIrsfaListens from './ClientsIrsfa/ClientIrsfaListens';
const { REACT_APP_IRSFA_WEB_SOCKET } = process.env;

const SocketIrsfa = new io(REACT_APP_IRSFA_WEB_SOCKET);

ClientIrsfaListens(SocketIrsfa);

export default SocketIrsfa;
